module.exports = __webpack_public_path__ + "static/media/wear.7a4c5be6.png";